import React from 'react';
import { motion } from 'framer-motion';
import { ClipboardListIcon, WrenchIcon, PlayCircleIcon } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
interface ProcessStep {
  number: string;
  icon: React.ReactNode;
  title: string;
  description: string;
}
const steps: ProcessStep[] = [{
  number: '01',
  icon: <ClipboardListIcon className="w-8 h-8" data-id="element-440" />,
  title: 'Elige tu plan',
  description: 'Selecciona el plan que se adapta a tu vehículo o flotilla. Te asesoramos sin compromiso.'
}, {
  number: '02',
  icon: <WrenchIcon className="w-8 h-8" data-id="element-441" />,
  title: 'Instalación a domicilio',
  description: 'Nuestros técnicos certificados instalan el GPS en tu ubicación, sin costo adicional.'
}, {
  number: '03',
  icon: <PlayCircleIcon className="w-8 h-8" data-id="element-442" />,
  title: 'Activa y monitorea',
  description: 'Accede a tu plataforma web o app móvil y empieza a rastrear en tiempo real.'
}];
export function ProcessSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  return <section ref={ref} className="w-full bg-brand-bg py-20 md:py-28 overflow-hidden" data-id="element-443">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-444">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-445">
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-white mb-4" data-id="element-446">
            Empieza a rastrear en 3 pasos
          </h2>
          <p className="font-body text-lg text-brand-text-secondary max-w-2xl mx-auto" data-id="element-447">
            Un proceso simple y rápido para comenzar a proteger tus vehículos
          </p>
        </motion.div>

        {/* Steps */}
        <div className="relative" data-id="element-448">
          {/* Connecting Line */}
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-0.5 -translate-y-1/2" data-id="element-449">
            <motion.div initial={{
            scaleX: 0
          }} animate={isVisible ? {
            scaleX: 1
          } : {}} transition={{
            duration: 1,
            delay: 0.3
          }} className="h-full bg-gradient-to-r from-transparent via-brand-accent/30 to-transparent origin-left" style={{
            backgroundImage: `repeating-linear-gradient(90deg, transparent, transparent 10px, rgba(0,200,255,0.3) 10px, rgba(0,200,255,0.3) 20px)`
          }} data-id="element-450" />
          </div>

          <div className="grid md:grid-cols-3 gap-8 md:gap-12 relative" data-id="element-451">
            {steps.map((step, index) => <motion.div key={step.number} initial={{
            opacity: 0,
            y: 40
          }} animate={isVisible ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.2 + index * 0.2
          }} className="relative" data-id="element-452">
                {/* Step Card */}
                <div className="glass rounded-2xl p-6 md:p-8 text-center relative z-10 h-full" data-id="element-453">
                  {/* Number */}
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-brand-accent/10 border border-brand-accent/30 mb-6" data-id="element-454">
                    <span className="font-heading font-bold text-3xl text-brand-accent" data-id="element-455">
                      {step.number}
                    </span>
                  </div>

                  {/* Icon */}
                  <div className="flex justify-center mb-4 text-brand-accent" data-id="element-456">
                    {step.icon}
                  </div>

                  {/* Content */}
                  <h3 className="font-heading font-bold text-xl text-white mb-3" data-id="element-457">
                    {step.title}
                  </h3>
                  <p className="font-body text-brand-text-secondary" data-id="element-458">
                    {step.description}
                  </p>
                </div>

                {/* Connector Arrow (mobile) */}
                {index < steps.length - 1 && <div className="md:hidden flex justify-center my-4" data-id="element-459">
                    <motion.div initial={{
                opacity: 0,
                y: -10
              }} animate={isVisible ? {
                opacity: 1,
                y: 0
              } : {}} transition={{
                duration: 0.4,
                delay: 0.4 + index * 0.2
              }} className="w-0.5 h-8 bg-gradient-to-b from-brand-accent/50 to-transparent" data-id="element-460" />
                  </div>}
              </motion.div>)}
          </div>
        </div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="text-center mt-12" data-id="element-461">
          <a href="#contacto" className="inline-flex items-center justify-center bg-brand-accent text-brand-bg font-subheading font-semibold px-8 py-4 rounded-lg hover:bg-brand-accent/90 transition-all duration-200 hover:shadow-xl hover:shadow-brand-accent/25" data-id="element-462">
            Comenzar Ahora
          </a>
        </motion.div>
      </div>
    </section>;
}